// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BEBaseElement } from './BEBaseElement';
import { BEEnum } from './BEEnum';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 枚举项 实体类
 * 枚举项
 */
export class EnumItem extends BEBaseElement {
  /** 枚举值 : 枚举值，一般采用2的指数 */
  private _itemValue: number;

  /** 设置：枚举值 */
  public get itemValue() {
    return this._itemValue;
  }

  /** 获取：枚举值 */
  public set itemValue(value: number) {
    this._itemValue = value;
  }

  /** 枚举 的ID */
  private _enum_ID: string;

  /** 获取：枚举 的ID */
  public get enum_ID() {
    return this._enum_ID;
  }

  /** 设置：枚举 的ID */
  public set enum_ID(value: string) {
    this._enum_ID = value;
  }

  /** 枚举  */
  private _enum: BEEnum;

  /** 获取：枚举  */
  public get enum() {
    return this._enum;
  }

  /** 设置：枚举  */
  public set enum(value: BEEnum) {
    this._enum = value;
    if (value !== null) {
      this.enum_ID = value.id;
    } else {
      this.enum_ID = '';
    }
  }

  constructor() {
    super();
    this._itemValue = 1;
    this._enum_ID = '';
    this._enum = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: EnumItem, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.itemValue = element.itemValue;
      this.enum_ID = element.enum_ID;
      if (hasReference && element.enum !== null) {
        this.enum = element.enum;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.itemValue = json.ItemValue;
    this.enum_ID = json.Enum_ID;
    // if (json.Enum !== null) {
    //   this.enum = BEEnum.Create(json.Enum);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.ItemValue = this.itemValue;
    json.Enum_ID = this.enum_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('代码属性', 'itemValue', '枚举值', EnumDataType.Int, this.itemValue, true, '枚举值，一般采用2的指数', '', '');
    return context;
  }

  static Create(json: any): EnumItem {
    const enumItem = new EnumItem();
    enumItem.Deserialize(json);
    enumItem.json = json;
    return enumItem;
  }
}
